import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	roleWiseUsersData: [],
	selectedUserDetails: {},
};

export const adminSlice = createSlice({
	name: "admin",
	initialState,
	reducers: {
		setRoleWiseUsersData: (state, actions) => {
			state.roleWiseUsersData = actions.payload.roleWiseUsersData;
		},
		setSelectedUserDetails: (state, actions) => {
			state.selectedUserDetails = actions.payload.selectedUserDetails;
		},
		setSelectedTab: (state, actions) => {
			state.selectedTab = actions.payload.selectedTab;
		},
	},
});

export const adminActions = adminSlice.actions;
export default adminSlice.reducer;
